import React, { useState } from 'react';
import uniqueId from '../../../forms/utilities/unique-id';
import { useI18n } from '../../utilities/i18n';

export default function ProductRecommendation({ product, onChange, i18nRecommendations }) {
    const i18n = useI18n();
    const id = uniqueId();

    const [selected, setSelected] = useState(product.selected)

    const { model, analysis } = product

    const changed = checked => {
        setSelected(checked)
        product.selected = checked;

        onChange(product)
    }

    return <div className="flex flex-wrap">

        <div className={`${onChange ? '-ml-2 sm:ml-0 w-full sm:w-auto' : ''}`}>
            <img className="w-20 sm:w-44 h-auto border border-grey-400" src={ model.meta.image } alt={ model.meta.title} />
        </div>

        <div className={`${onChange ? 'flex-1 mt-1 md:mt-0 sm:pl-8' : ' pl-8 flex-1'}`}>
            <h2 className="text-2xl font-bold">
                { model.meta.title } { analysis.unitsRequired !== 1 ? 'x' + analysis.unitsRequired : null}
            </h2>

            <div className="mt-1 prose leading-6 text-grey-500">{ i18nRecommendations.reserveDuty }: { analysis.reserveDuty }%</div>

            <div className="mt-4 prose leading-6 text-grey-500" dangerouslySetInnerHTML={{ __html: model.meta.bodyCopy }} />

            { onChange ? <div className="mt-6 flex flex-wrap items-center gap-6 md:gap-10">
                <div className="w-full sm:w-auto">
                    <label className="inline-flex items-center space-x-3 p-2 border-2 border-grey-200 rounded-lg text-sm hover:bg-grey-100 cursor-pointer" htmlFor={ id }>
                        <input onChange={ event => changed(event.target.checked) } checked={ selected } id={ id } name="recommendations" type="checkbox" className="styled-input form-tick"/>
                        <span>{ i18n.recommendations.selectProduct }</span>
                    </label>
                </div>
                <div className="w-full sm:w-auto">
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a target="_blank" href={ model.meta.url } className="flex items-center space-x-2 underline hover:text-green text-sm">
                        <span><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M4.2 6.4h7.2V4.6H4.2v1.8zm0 5.4h3.6V10H4.2v1.8zm0-2.7h7.2V7.3H4.2v1.8zm-1.8 4.5h10.8V2.8H2.4v10.8zM13.2 1H2.4C1.41 1 .6 1.81.6 2.8v10.8c0 .99.81 1.8 1.8 1.8h10.8c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8h0z" fill="currentColor" stroke="#FFF" strokeWidth=".5" fillRule="evenodd"/></svg></span>
                        <span>{ i18n.recommendations.viewProduct }</span>
                    </a>
                </div>
            </div> : null }

        </div>
    </div>;
}
